import { Network, Alchemy } from 'alchemy-sdk';
import { ALCHEMY_API_KEY } from '../constants';

const DEFAULT_PAGE_SIZE = 100;

export const getAllNftsFromAlchemy = async (ownerAddress, contractAddress = null, network = Network.BASE_SEPOLIA) => {
  let tokens = [];
  let pageKey = null;
  const alchemy = new Alchemy({
    apiKey: ALCHEMY_API_KEY,
    network: network
  });

  do {
    const options = {
      contractAddresses: contractAddress ? [contractAddress] : undefined,
      pageKey,
      pageSize: DEFAULT_PAGE_SIZE
    };

    const nfts = await alchemy.nft.getNftsForOwner(ownerAddress, options);
    tokens = [...tokens, ...nfts.ownedNfts];
    pageKey = nfts.pageKey;

  } while (pageKey);

  return tokens;
};

export const getAllOgs = async ({ownerAddress = 'fake', token = 'nope', arWalletAddress = 'none' }) => {
  // This is a test address where there are OGs
  // ownerAddress = '0xaBb94DBdD360CC0eE92B59420A49019e760e32b3';
  // arWalletAddress = 'jsaAHShOKWeTBPE8SeHRe874TnxEDmPL7ukh14fQmiw';
  const response = await fetch(`https://4shc66ds38.execute-api.us-east-1.amazonaws.com/ogs/${ownerAddress}?token=${token}&arAddress=${arWalletAddress}`);
  if (!response.ok) {
    return [];
  }
  return await response.json();
};
